import React from "react";

// Selected milestones from the existing CV; the current role has no inferred start date.
const milestones = [
  { date: "2009 — 2013", institution: "清华大学", detail: "生命科学 · 学士" },
  { date: "2013 — 2017", institution: "香港大学", detail: "植物分子生物学 · 博士" },
  { date: "2018 — 2024", institution: "香港大学", detail: "博士后" },
  { date: "现任 / Present", institution: "上海交通大学", detail: "农业与生物学院 · 助理研究员" },
];

export default function AcademicBackground() {
  return (
    <section id="background" className="academic-background" aria-labelledby="background-title">
      <div className="background-heading">
        <h2 id="background-title">
          学术经历 <span lang="en">/ Background</span>
        </h2>
        <p>从植物分子生物学出发，探索生命系统的更多可能。</p>
      </div>
      <ol className="background-grid">
        {milestones.map(({ date, institution, detail }) => (
          <li className="background-stop" key={date}>
            <span className="background-date">{date}</span>
            <h3>{institution}</h3>
            <p>{detail}</p>
          </li>
        ))}
      </ol>
    </section>
  );
}
